import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../../context/GlobalContext";
import useConfirm from "../Control/useConfirm";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import homePage from "./HomePage.module.css";
import { getTilesByUserType } from "../../constants/tilesConfig";
import TileRenderer from "../Control/TileRenderer";

const Admin = () => {
  const { state, logout } = useAuth();
  const access = state.user?.access || [];
  const history = useHistory();
  const [Dialog, confirmLogoutUser] = useConfirm(
    "LOG OUT",
    "Are you sure you want to log out?",
  );

  const logoutUser = async () => {
    const ans = await confirmLogoutUser();
    if (ans) {
      logout();
      history.push("/");
    }
  };

  if (!state.user) {
    logout();
    history.push("/");
    return null;
  }

  if (state.user?.userType === 2) {
    const adminTiles = getTilesByUserType(2);

    return (
      <>
        <main className={`${homePage.container} ${homePage.main}`}>
          {adminTiles.map(tile => {
            // Check if user has access to this tile
            const hasAccess = access.some((obj) => obj.id === tile.id);

            // Check if tile should be hidden for specific users
            if (tile.hideForUsers && tile.hideForUsers.includes(state?.user?._id)) {
              return null;
            }

            // Only render if user has access
            if (!hasAccess) {
              return null;
            }

            return (
              <TileRenderer
                key={tile.id}
                tile={tile}
              />
            );
          })}

          {/* Logout Tile */}
          <div>
            <div
              style={{ cursor: "pointer" }}
              className="panel"
              onClick={logoutUser}
            >
              <ExitToAppIcon style={{ fontSize: "3rem", color: "maroon" }} />
            </div>
            <p className="card-btn-para">
              Logout <span className="card-btn-span">Aqua</span>
            </p>
          </div>
        </main>

        <Dialog isSubmitContent={false} />
      </>
    );
  } else {
    return (
      <div>
        <h1>Page Not Found</h1>
      </div>
    );
  }
};

export default Admin;
